import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { BRAND } from './brand';
import './styles.css';

// Apply the build-time brand: theme tokens in styles.css key off <html data-brand>.
document.documentElement.dataset.brand = BRAND.id;
document.title = `AI Token Cost Estimator | ${BRAND.name}`;

const rootElement = document.getElementById('root');
if (!rootElement) {
	throw new Error('Root element #root not found in index.html');
}

createRoot(rootElement).render(
	<StrictMode>
		<App />
	</StrictMode>,
);
